module.exports = require("lodash/toInteger");